import { formatNumberForLocale, parseLocaleNumber } from  "../../utils/locale";


export const MoneyPicker = ({ setSum, sum }) => {
    const handleClick = (value) => {
        setSum(Number(sum) + Number(value));
    };

    return (
        <>    <div className="flex flex-wrap gap-2 justify-center mb-10">
            <button className="money-btn" onClick={() => setSum(0)}>
                0
            </button>
            <button className="money-btn" onClick={() => handleClick(1)}>
                1
            </button>
            <button className="money-btn" onClick={() => handleClick(5)}>
                5
            </button>
            <button className="money-btn" onClick={() => handleClick(10)}>
                10
            </button>
            <button className="money-btn" onClick={() => handleClick(20)}>
                20
            </button>
            <button className="money-btn" onClick={() => handleClick(50)}>
                50
            </button>
             <button className="money-btn" onClick={() => handleClick(100)}>
                100
            </button>
             <button className="money-btn" onClick={() => handleClick(500)}>
                500
            </button>
        </div>

            <div className="w-full max-w-sm space-y-2 mb-10 flex items-center justify-center relative">
                {/* Positioned the euro symbol on the left side of the input */}
                <span className="absolute right-5 mt-3 wtext text-5xl">€</span>
                <input
                    className="focus:outline-none focus:border-none text-center appearance-none text-5xl"
                    style={{
                        border: 'none',
                        boxShadow: 'none',
                        backgroundColor: 'transparent',
                    }}
                    type="text"
                    name="balance"
                    id="balance"
                    onChange={(e) => setSum(parseLocaleNumber(e.target.value))}
                    value={formatNumberForLocale(sum)}
                    placeholder="0"
                    inputMode="numeric"
                />
            </div>

           
        </>



    );
};
